import type { RoutesFilter } from '../models';

export const MS_PER_DAY = 86_400_000;
export const SCHEDULED_RANGE_MAX_DAYS = 35;

const ROUTE_ID_REGEX =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export function getScheduledDateRangeValidationMessage(
  filter: RoutesFilter
): string | null {
  const routeId = filter.routeId?.trim();
  if (routeId) {
    return ROUTE_ID_REGEX.test(routeId) ? null : 'El ID de ruta no es válido.';
  }

  const fromRaw = filter.scheduledFrom?.trim();
  const toRaw = filter.scheduledTo?.trim();
  if (!fromRaw || !toRaw) {
    return 'Debe indicar la fecha desde y la fecha hasta.';
  }

  const fromMs = new Date(fromRaw).getTime();
  const toMs = new Date(toRaw).getTime();
  if (Number.isNaN(fromMs) || Number.isNaN(toMs)) {
    return null;
  }

  if (fromMs > toMs) {
    return 'La fecha desde no puede ser posterior a la fecha hasta.';
  }

  return null;
}

export function getScheduledExportRangeValidationMessage(
  filter: RoutesFilter
): string | null {
  const baseMessage = getScheduledDateRangeValidationMessage(filter);
  if (baseMessage) return baseMessage;
  if (filter.routeId?.trim()) return null;

  const fromMs = new Date(filter.scheduledFrom!.trim()).getTime();
  const toMs = new Date(filter.scheduledTo!.trim()).getTime();
  if (Number.isNaN(fromMs) || Number.isNaN(toMs)) {
    return null;
  }

  if (toMs - fromMs > SCHEDULED_RANGE_MAX_DAYS * MS_PER_DAY) {
    return `Para exportar, el rango de fechas no puede superar ${SCHEDULED_RANGE_MAX_DAYS} días.`;
  }

  return null;
}
